import React, { Component } from 'react'
import { SigninForm } from './form'
import { SplitScreenLayout } from 'app/common/layout'

type Props = {
    fetchPageData: () => void,
    reset: () => void,
    redirectURL: string => void,
    error: any,
    networkError: any,
    location: Object
}

class SigninComponent extends Component<Props> {
    componentDidMount() {
        const { fetchPageData, reset } = this.props
        reset()
        fetchPageData()
    }

    render() {
        const url = new URL(window.location.href)
        const searchParams = new URLSearchParams(url.search)
        const fromUrlFromSearchParams = searchParams.get('fromUrl')
        const isSearchParamRedirectValid =
            !!fromUrlFromSearchParams &&
            !fromUrlFromSearchParams.startsWith('http') //only allow relative paths

        const { error, networkError, location } = this.props
        const { state } = location || {}
        let redirectTo = null
        if (state) {
            const { from } = state
            if (from) {
                redirectTo = from.pathname
            }
        }

        if (isSearchParamRedirectValid && fromUrlFromSearchParams) {
            redirectTo = fromUrlFromSearchParams
        }

        return (
            <SplitScreenLayout
                breadcrumbKey="signin.breadcrumb.end"
                titleKey="signin.title"
                leftBlock={<SigninForm redirectTo={redirectTo} />}
                className="signin"
                noBackground
                error={error}
                networkError={networkError}
            />
        )
    }
}

export { SigninComponent }
